import { FieldExpression, NodeExpression, toString as luceneToString } from 'lucene';

import { AllQualityIssueBatch } from '../models/all-quality-issue-batch';
import { QualityBatch } from '../models/quality-batch';

function batchFilter(batche: QualityBatch) {
	const { batchReference, qty } = batche;
	let allCondition: FieldExpression | NodeExpression = {
		field: 'batchReference',
		term: batchReference,
		quoted: true
	};
	if (qty) {
		const quantity1Field: FieldExpression = {
			field: 'qtyBatchGross',
			term: String(qty),
			quoted: false
		};
		const quantity2Field: FieldExpression = {
			field: 'qtyBatchGross',
			term: String(qty / 1000),
			quoted: false
		};
		const quantity3Field: FieldExpression = {
			field: 'qtyBatchNet',
			term: String(qty),
			quoted: false
		};
		const quantity4Field: FieldExpression = {
			field: 'qtyBatchNet',
			term: String(qty / 1000),
			quoted: false
		};
		const quantity5Field: FieldExpression = {
			field: 'qtyInvoiced',
			term: String(qty),
			quoted: false
		};
		const quantity6Field: FieldExpression = {
			field: 'qtyInvoiced',
			term: String(qty / 1000),
			quoted: false
		};

		const qty1Node: NodeExpression = {
			left: quantity1Field,
			operator: 'OR',
			parenthesized: false,
			right: quantity2Field
		};

		const qty2Node: NodeExpression = {
			left: qty1Node,
			operator: 'OR',
			parenthesized: false,
			right: quantity3Field
		};

		const qty3Node: NodeExpression = {
			left: qty2Node,
			operator: 'OR',
			parenthesized: false,
			right: quantity4Field
		};

		const qty4Node: NodeExpression = {
			left: qty3Node,
			operator: 'OR',
			parenthesized: false,
			right: quantity5Field
		};

		const qty5Node: NodeExpression = {
			left: qty4Node,
			operator: 'OR',
			parenthesized: true,
			right: quantity6Field
		};

		allCondition = {
			left: allCondition,
			operator: 'AND',
			parenthesized: false,
			right: qty5Node
		};
	}
	return allCondition;
}

export function batchesFilter(batches?: QualityBatch[]) {
	if (!batches || batches.length === 0) {
		return undefined;
	}
	let allCondition = batchFilter(batches[0]);
	for (const batch of batches.slice(1)) {
		const rightPart = batchFilter(batch);
		allCondition = {
			left: allCondition,
			operator: 'OR',
			right: rightPart,
			parenthesized: true
		};
	}

	return luceneToString(allCondition);
}

export function sumBatchQuantitiesRoundValue(batchList: AllQualityIssueBatch[]) {
	let totalBatchQty = 0;
	for (const batch of batchList) {
		totalBatchQty += batch.claimedQuantityValue ? batch.claimedQuantityValue * 1000 : 0;
	}
	return totalBatchQty / 1000;
}
